"use client"
import { useParams } from "react-router-dom"
import { ParallaxProvider } from "react-scroll-parallax"
import Header from "../Header/Header"
import ServicioLayout from "../Servicios/ServicioLayout"
import styles from "./PlantillaServicios.module.css"
import { serviciosData } from "../Servicios/serviciosData"

function PlantillaServicios() {
  const { servicioId } = useParams()
  const servicioData = serviciosData[servicioId]

  return (
    <ParallaxProvider>
      <div className={styles.landingpage}>
        <Header />
        <div className={styles.parallaxsection}>
          <div className={styles.parallaxbackground}></div>
          {servicioData && <ServicioLayout servicioData={servicioData} />}
        </div>
      </div>
    </ParallaxProvider>
  )
}

export default PlantillaServicios

